import styled from "styled-components";
import { mobile } from "../../../../../../ui/_themes/constants";
import { SettingButton } from "../../../../../../ui/SettingButton";

export const ExternalPaneButton = styled(SettingButton)`
  display: inline-block;
  padding: 0.4em 2em;
  margin: 0 auto;

  span:first-child {
    font-size: ${mobile.fontSize.l};
    text-transform: uppercase;
  }
`;
